import React, { Component } from 'react';
import { func, arrayOf, string } from 'prop-types';
import { get } from 'lodash';
import styles from './styles.scss';
import { normalizeMetric } from '../../../helpers/validate';
import { shapeOfKeywordData, getKeywordColumnWidth } from './../constant';

export default class KeywordTableRow extends Component {
  static propTypes = {
    data: shapeOfKeywordData,
    onCellClick: func,
    columnsToDisplay: arrayOf(string)
  }

  static defaultProps = {
    data: {},
    columnsToDisplay: ['keywordValue', 'adVisits']
  }

  render() {
    const { 
      data,
      onCellClick,
      columnsToDisplay
    } = this.props;
    const formattedData = {
      ...data,
      adVisits: data.adVisits && data.adVisits.toFixed(1),
      newAdUsers: data.newAdUsers && data.newAdUsers.toFixed(1)
    }
    
    return (
      <div className={styles.tableRow}>
        {
          columnsToDisplay && columnsToDisplay.map((key, index) => {
            const width = getKeywordColumnWidth(columnsToDisplay.length, index)
            let value = get(formattedData, key);
            if (key !== 'keywordValue') {
              value = normalizeMetric(value);
            }
            return (
              <div
                key={key}
                className={styles.tableCell}
                onClick={onCellClick({data, key})}
                style={{ width: `${width}%`}}
              >
                {value}
              </div>
            )
          })
        }
      </div>
    )
  }
}
